/* JE PEUX — theme.js
 * Interações do chrome:
 *  - Menu mobile
 *  - Drawer de busca (predictive search)
 *  - Drawer de carrinho (cart.js)
 *  - Badge do carrinho com animação de pulso
 */
(function () {
  'use strict';

  // ------------------------------------------------------------
  // Mobile menu
  // ------------------------------------------------------------
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    var iconOpen = toggle.querySelector('[data-menu-icon="open"]');
    var iconClose = toggle.querySelector('[data-menu-icon="close"]');

    toggle.addEventListener('click', function () {
      var willOpen = nav.hasAttribute('hidden');
      if (willOpen) {
        nav.removeAttribute('hidden');
      } else {
        nav.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', String(willOpen));
      toggle.setAttribute('aria-label', willOpen ? 'Fechar menu' : 'Abrir menu');
      if (iconOpen) iconOpen.hidden = willOpen;
      if (iconClose) iconClose.hidden = !willOpen;
    });
  }

  // ------------------------------------------------------------
  // Drawer core — visibility, backdrop, esc, focus trap
  // ------------------------------------------------------------
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function createDrawer(root, options) {
    if (!root) return null;
    var panel = root.querySelector('[data-drawer-panel]');
    var backdrop = root.querySelector('[data-drawer-backdrop]');
    var closes = root.querySelectorAll('[data-drawer-close]');
    var openClass = options.openClass || 'is-open';
    var direction = options.direction || 'right'; // right | top
    var lastFocused = null;

    function setPanelTransform(open) {
      if (!panel) return;
      if (direction === 'top') {
        panel.style.transform = open ? 'translateY(0)' : 'translateY(-100%)';
      } else {
        panel.style.transform = open ? 'translateX(0)' : 'translateX(100%)';
      }
    }

    function open() {
      lastFocused = document.activeElement;
      root.classList.add(openClass);
      root.style.opacity = '1';
      root.style.pointerEvents = 'auto';
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // Force layout so transform transitions
      requestAnimationFrame(function () {
        setPanelTransform(true);
      });
      if (options.onOpen) options.onOpen();
      // Focus the first focusable element inside the panel
      setTimeout(function () {
        var target = options.initialFocus
          ? root.querySelector(options.initialFocus)
          : panel && panel.querySelector('input, button, a, [tabindex]');
        if (target && typeof target.focus === 'function') target.focus();
      }, 50);
    }

    function close() {
      root.classList.remove(openClass);
      setPanelTransform(false);
      root.style.opacity = '0';
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () {
        root.style.pointerEvents = 'none';
      }, 300);
      if (options.onClose) options.onClose();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function toggle() {
      if (root.classList.contains(openClass)) close();
      else open();
    }

    if (backdrop) backdrop.addEventListener('click', close);
    Array.prototype.forEach.call(closes, function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains(openClass)) close();
    });

    // Set initial closed position
    setPanelTransform(false);

    return { open: open, close: close, toggle: toggle, root: root };
  }

  // ------------------------------------------------------------
  // Search drawer (predictive search)
  // ------------------------------------------------------------
  function initSearchDrawer() {
    var root = document.getElementById('search-drawer');
    var toggle = document.querySelector('[data-search-toggle]');
    if (!root || !toggle) return;

    var input = root.querySelector('[data-search-input]');
    var form = root.querySelector('[data-search-form]');
    var empty = root.querySelector('[data-search-empty]');
    var loading = root.querySelector('[data-search-loading]');
    var list = root.querySelector('[data-search-list]');
    var items = root.querySelector('[data-search-items]');
    var count = root.querySelector('[data-search-count]');
    var noresults = root.querySelector('[data-search-noresults]');
    var queryOut = root.querySelector('[data-search-query]');
    var viewall = root.querySelector('[data-search-viewall]');
    var quickButtons = root.querySelectorAll('[data-search-quick]');

    var drawer = createDrawer(root, {
      direction: 'top',
      initialFocus: '[data-search-input]',
      onClose: function () {
        if (input) input.value = '';
        showState('empty');
      },
    });

    toggle.addEventListener('click', function () {
      toggle.setAttribute('aria-expanded', String(!root.classList.contains('is-open')));
      drawer.toggle();
    });

    function showState(state) {
      [empty, loading, list, noresults].forEach(function (el) {
        if (el) el.classList.add('hidden');
      });
      if (state === 'empty' && empty) empty.classList.remove('hidden');
      if (state === 'loading' && loading) loading.classList.remove('hidden');
      if (state === 'list' && list) list.classList.remove('hidden');
      if (state === 'noresults' && noresults) noresults.classList.remove('hidden');
    }

    function renderResult(product) {
      var li = document.createElement('li');
      li.className = 'flex gap-3 p-3 rounded-lg hover:bg-jepeux-bone transition-colors';
      var imgUrl = (product.featured_image && product.featured_image.url) || product.image || '';
      var img = imgUrl
        ? '<img src="' + imgUrl + '" alt="' + escapeHtml(product.title) + '" class="w-16 h-16 rounded-md object-cover bg-jepeux-bone" loading="lazy">'
        : '<div class="w-16 h-16 rounded-md bg-jepeux-bone"></div>';
      var price = product.price
        ? '<span class="font-display text-sm text-jepeux-noir">' + formatMoney(parseInt(product.price, 10)) + '</span>'
        : '';
      li.innerHTML =
        '<a href="' + product.url + '" class="flex gap-3 w-full items-center">' +
        img +
        '<div class="flex-1 min-w-0">' +
        '<p class="font-display text-base text-jepeux-noir truncate">' + escapeHtml(product.title) + '</p>' +
        (product.vendor ? '<p class="text-xs text-jepeux-ash">' + escapeHtml(product.vendor) + '</p>' : '') +
        price +
        '</div>' +
        '</a>';
      return li;
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var abortController = null;
    var debounceTimer = null;

    function runSearch(q) {
      if (!q || q.length < 2) {
        showState('empty');
        return;
      }
      if (abortController) abortController.abort();
      abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
      showState('loading');

      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url, { signal: abortController && abortController.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          if (products.length === 0) {
            if (queryOut) queryOut.textContent = '"' + q + '"';
            showState('noresults');
            return;
          }
          if (items) items.innerHTML = '';
          products.forEach(function (p) {
            if (items) items.appendChild(renderResult(p));
          });
          if (count) count.textContent = products.length + (products.length === 1 ? ' resultado' : ' resultados');
          if (viewall) viewall.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
          showState('list');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          showState('empty');
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { runSearch(q); }, 200);
      });
    }

    Array.prototype.forEach.call(quickButtons, function (btn) {
      btn.addEventListener('click', function () {
        var term = btn.getAttribute('data-search-quick') || '';
        if (input) {
          input.value = term;
          input.focus();
        }
        runSearch(term);
      });
    });

    // Submit goes to full search page (default form behavior)
    if (form) {
      form.addEventListener('submit', function () {
        drawer.close();
      });
    }

    return drawer;
  }

  // ------------------------------------------------------------
  // Cart drawer
  // ------------------------------------------------------------
  function initCartDrawer() {
    var root = document.getElementById('cart-drawer');
    var toggle = document.querySelector('[data-cart-toggle]');
    if (!root || !toggle) return;

    var body = root.querySelector('[data-cart-body]');
    var title = root.querySelector('[data-cart-title]');
    var subtotal = root.querySelector('[data-cart-subtotal]');
    var footer = root.querySelector('[data-cart-footer]');

    var drawer = createDrawer(root, { direction: 'right' });

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      toggle.setAttribute('aria-expanded', String(!root.classList.contains('is-open')));
      drawer.toggle();
      refreshCart();
    });

    function pluralize(n) {
      if (n === 0) return 'Vazio';
      if (n === 1) return '1 item';
      return n + ' itens';
    }

    function renderEmpty() {
      if (!body) return;
      body.innerHTML =
        '<div class="flex flex-col items-center justify-center text-center px-6 py-16 gap-4">' +
        '<div class="w-16 h-16 rounded-full bg-jepeux-bone flex items-center justify-center text-jepeux-bronze">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>' +
        '</div>' +
        '<p class="font-display text-h4 text-jepeux-noir">Seu carrinho está vazio.</p>' +
        '<p class="text-jepeux-ash">Descubra a rotina ideal e monte sua seleção.</p>' +
        '<a href="/collections/all" class="inline-flex items-center justify-center gap-2 font-medium bg-jepeux-noir text-jepeux-ivory border border-jepeux-noir hover:bg-jepeux-bronze hover:border-jepeux-bronze rounded-md px-6 py-3 mt-2 transition-colors">Explorar produtos</a>' +
        '</div>';
    }

    function renderItems(cart) {
      if (!body) return;
      if (cart.item_count === 0) {
        renderEmpty();
        return;
      }
      var ul = document.createElement('ul');
      ul.className = 'divide-y divide-jepeux-line';
      ul.setAttribute('role', 'list');
      ul.setAttribute('data-cart-items', '');

      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'p-6 flex gap-4';
        li.setAttribute('data-cart-line', item.key);
        var img = item.image
          ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" class="w-full h-full object-cover" loading="lazy">'
          : '';
        var variantLine = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="text-xs text-jepeux-ash mt-0.5">' + escapeHtml(item.variant_title) + '</p>'
          : '';
        li.innerHTML =
          '<a href="' + item.url + '" class="shrink-0 block w-20 h-20 rounded-md overflow-hidden bg-jepeux-bone">' + img + '</a>' +
          '<div class="flex-1 min-w-0">' +
          '<a href="' + item.url + '" class="font-display text-base text-jepeux-noir hover:text-jepeux-bronze transition-colors block truncate">' + escapeHtml(item.product_title) + '</a>' +
          variantLine +
          '<div class="flex items-center justify-between mt-3">' +
          '<div class="inline-flex items-center border border-jepeux-line rounded-md">' +
          '<button type="button" class="p-2 text-jepeux-noir hover:text-jepeux-bronze" aria-label="Diminuir" data-qty-decrease data-line-key="' + item.key + '" data-line-qty="' + item.quantity + '"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path></svg></button>' +
          '<span class="px-3 font-mono text-sm text-jepeux-noir">' + item.quantity + '</span>' +
          '<button type="button" class="p-2 text-jepeux-noir hover:text-jepeux-bronze" aria-label="Aumentar" data-qty-increase data-line-key="' + item.key + '" data-line-qty="' + item.quantity + '"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg></button>' +
          '</div>' +
          '<div class="flex items-center gap-3">' +
          '<span class="font-display text-sm text-jepeux-noir">' + formatMoney(item.final_line_price) + '</span>' +
          '<button type="button" class="p-2 text-jepeux-ash hover:text-jepeux-bronze transition-colors" aria-label="Remover" data-line-remove data-line-key="' + item.key + '"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg></button>' +
          '</div>' +
          '</div>' +
          '</div>';
        ul.appendChild(li);
      });

      body.innerHTML = '';
      body.appendChild(ul);
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function syncChrome(cart) {
      if (title) title.textContent = pluralize(cart.item_count);
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (footer) {
        if (cart.item_count === 0) footer.classList.add('hidden');
        else footer.classList.remove('hidden');
      }
      updateCartBadge(cart.item_count);
    }

    function refreshCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderItems(cart);
          syncChrome(cart);
          return cart;
        })
        .catch(function () {});
    }

    function changeLine(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderItems(cart);
          syncChrome(cart);
        });
    }

    // Event delegation inside cart body (since content is re-rendered)
    if (body) {
      body.addEventListener('click', function (e) {
        var dec = e.target.closest && e.target.closest('[data-qty-decrease]');
        var inc = e.target.closest && e.target.closest('[data-qty-increase]');
        var rem = e.target.closest && e.target.closest('[data-line-remove]');
        if (dec) {
          var key = dec.getAttribute('data-line-key');
          var q = parseInt(dec.getAttribute('data-line-qty'), 10) || 1;
          changeLine(key, Math.max(0, q - 1));
        } else if (inc) {
          var key2 = inc.getAttribute('data-line-key');
          var q2 = parseInt(inc.getAttribute('data-line-qty'), 10) || 0;
          changeLine(key2, q2 + 1);
        } else if (rem) {
          changeLine(rem.getAttribute('data-line-key'), 0);
        }
      });
    }

    var lastAddedKey = null;

    function highlightJustAdded() {
      if (!body || !lastAddedKey) return;
      var line = body.querySelector('[data-cart-line="' + cssEscape(lastAddedKey) + '"]');
      if (line) {
        line.classList.add('is-just-added');
        setTimeout(function () { line.classList.remove('is-just-added'); }, 1400);
      }
    }

    function cssEscape(s) {
      return String(s).replace(/([^a-zA-Z0-9_-])/g, '\\$1');
    }

    function showToast(message) {
      var toast = document.querySelector('[data-cart-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'cart-toast';
        toast.setAttribute('data-cart-toast', '');
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.innerHTML =
          '<span class="cart-toast__icon" aria-hidden="true">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
          '</span><span data-cart-toast-msg></span>';
        document.body.appendChild(toast);
      }
      var msg = toast.querySelector('[data-cart-toast-msg]');
      if (msg) msg.textContent = message;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      clearTimeout(toast._hideTimer);
      toast._hideTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
    }

    // Intercept <form action="/cart/add"> submits, push to cart, open drawer
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;
      e.preventDefault();

      // Desabilita o botão com estado de "adicionando"
      var submitBtn = form.querySelector('button[type="submit"]');
      var originalLabel = null;
      if (submitBtn) {
        originalLabel = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.innerHTML = '<span class="inline-block w-4 h-4 mr-2 align-middle rounded-full border-2 border-current border-t-transparent animate-spin"></span>Adicionando…';
      }

      // Abre o drawer imediatamente com estado de loading — feedback instantâneo
      if (body) {
        body.innerHTML =
          '<div class="px-6 py-10 flex items-center justify-center gap-3 text-jepeux-ash">' +
          '<span class="inline-block w-4 h-4 rounded-full border-2 border-jepeux-line border-t-jepeux-bronze animate-spin"></span>' +
          '<span class="font-mono text-sm">Adicionando ao ritual…</span>' +
          '</div>';
      }
      drawer.open();

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (addedItem) {
          lastAddedKey = addedItem && addedItem.key ? addedItem.key : null;
          showToast(addedItem && addedItem.product_title ? addedItem.product_title + ' adicionado' : 'Produto adicionado');
          return refreshCart().then(highlightJustAdded);
        })
        .catch(function (err) {
          if (body) {
            body.innerHTML =
              '<div class="px-6 py-10 text-center text-jepeux-ash">' +
              '<p class="font-display text-h4 text-jepeux-noir mb-2">Não conseguimos adicionar.</p>' +
              '<p class="text-sm">' + ((err && err.description) || 'Tente novamente em instantes.') + '</p>' +
              '</div>';
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
            if (originalLabel !== null) submitBtn.innerHTML = originalLabel;
          }
        });
    });

    return { drawer: drawer, refresh: refreshCart };
  }

  // ------------------------------------------------------------
  // Cart badge
  // ------------------------------------------------------------
  function updateCartBadge(count) {
    var badge = document.querySelector('[data-cart-badge]');
    var btn = document.querySelector('[data-cart-toggle]');
    if (!badge || !btn) return;
    var prev = parseInt(btn.getAttribute('data-cart-count'), 10) || 0;
    btn.setAttribute('data-cart-count', String(count));
    btn.setAttribute('aria-label', 'Carrinho (' + count + ' itens)');
    badge.textContent = String(count);
    if (count === 0) {
      badge.classList.add('opacity-0', 'scale-75');
    } else {
      badge.classList.remove('opacity-0', 'scale-75');
    }
    if (count > prev) {
      badge.style.transform = 'scale(1.3)';
      setTimeout(function () { badge.style.transform = ''; }, 220);
    }
  }

  // ------------------------------------------------------------
  // PDP — Calculadora de frete (via Frenet/Shopify shipping_rates)
  // ------------------------------------------------------------
  function initShippingCalculator() {
    var root = document.querySelector('[data-shipping-calc]');
    if (!root) return;
    var input = root.querySelector('[data-shipping-zip]');
    var btn = root.querySelector('[data-shipping-calc-btn]');
    var results = root.querySelector('[data-shipping-results]');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!input || !btn || !results || !form) return;

    // Máscara 00000-000
    input.addEventListener('input', function () {
      var v = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
      input.classList.remove('is-invalid');
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); btn.click(); }
    });

    function showMsg(html, isError) {
      results.hidden = false;
      results.innerHTML = '<p class="pdp-shipping__msg' + (isError ? ' pdp-shipping__msg--error' : '') + '">' + html + '</p>';
    }
    function showLoading() {
      results.hidden = false;
      results.innerHTML = '<p class="pdp-shipping__msg"><span class="pdp-shipping__spinner" aria-hidden="true"></span>Calculando frete…</p>';
    }
    function daysFromNow(dateStr) {
      if (!dateStr) return null;
      var d = new Date(dateStr);
      if (isNaN(d.getTime())) return null;
      return Math.max(0, Math.ceil((d - new Date()) / 86400000));
    }
    function rateDays(rate) {
      // Tenta campos em ordem de preferência (diferentes apps/contextos usam nomes diferentes)
      var min = null, max = null;
      if (Array.isArray(rate.delivery_range) && rate.delivery_range.length >= 2) {
        min = daysFromNow(rate.delivery_range[0]);
        max = daysFromNow(rate.delivery_range[1]);
      } else if (rate.min_delivery_date || rate.max_delivery_date) {
        min = daysFromNow(rate.min_delivery_date);
        max = daysFromNow(rate.max_delivery_date);
      } else if (rate.delivery_date) {
        min = max = daysFromNow(rate.delivery_date);
      } else if (Array.isArray(rate.delivery_days)) {
        min = rate.delivery_days[0];
        max = rate.delivery_days[rate.delivery_days.length - 1];
      } else {
        // Último recurso: regex no nome ("PAC - 5 dias", "Sedex (2 a 3 dias)")
        var m = /(\d+)\s*(?:a|-|até)\s*(\d+)/i.exec(rate.name || '') || /(\d+)\s*dias?/i.exec(rate.name || '');
        if (m) { min = parseInt(m[1], 10); max = parseInt(m[2] || m[1], 10); }
      }
      return { min: min, max: max };
    }
    function formatDays(rate) {
      var d = rateDays(rate);
      if (d.min == null && d.max == null) return '';
      if (d.min === d.max || d.max == null) return 'em ' + d.min + ' dia' + (d.min === 1 ? '' : 's') + ' útil' + (d.min === 1 ? '' : 'eis');
      if (d.min == null) return 'em até ' + d.max + ' dias úteis';
      return 'em ' + d.min + ' a ' + d.max + ' dias úteis';
    }
    function pickThree(rates) {
      // Ordena por prazo máximo (mais rápido primeiro)
      var sorted = rates.slice().sort(function (a, b) {
        var ad = rateDays(a).max; if (ad == null) ad = 999;
        var bd = rateDays(b).max; if (bd == null) bd = 999;
        return ad - bd;
      });
      var picked;
      if (sorted.length === 1) {
        picked = [{ rate: sorted[0], label: 'Normal' }];
      } else if (sorted.length === 2) {
        picked = [
          { rate: sorted[0], label: 'Expresso' },
          { rate: sorted[1], label: 'Normal' }
        ];
      } else {
        picked = [
          { rate: sorted[0], label: 'Expresso' },
          { rate: sorted[Math.floor(sorted.length / 2)], label: 'Rápido' },
          { rate: sorted[sorted.length - 1], label: 'Normal' }
        ];
      }
      return picked;
    }
    function renderRate(item) {
      var rate = item.rate;
      var price = parseFloat(rate.price) || 0;
      var priceHtml = price === 0
        ? '<span class="pdp-shipping__rate-price pdp-shipping__rate-price--free">Grátis</span>'
        : '<span class="pdp-shipping__rate-price">' + formatMoney(Math.round(price * 100)) + '</span>';
      var days = formatDays(rate);
      return (
        '<div class="pdp-shipping__rate">' +
          '<div><span class="pdp-shipping__rate-name">' + escapeHtml(item.label) + '</span>' +
          (days ? '<span class="pdp-shipping__rate-days">' + days + '</span>' : '') +
          '</div>' +
          priceHtml +
        '</div>'
      );
    }
    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    btn.addEventListener('click', function () {
      var zip = (input.value || '').replace(/\D/g, '');
      if (zip.length !== 8) {
        input.classList.add('is-invalid');
        input.focus();
        showMsg('CEP inválido. Use o formato 00000-000.', true);
        return;
      }

      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput && variantInput.value;
      if (!variantId) { showMsg('Selecione uma variante do produto.', true); return; }

      btn.disabled = true;
      showLoading();

      var ghostAdded = false;
      var cleanup = function () { btn.disabled = false; };

      // 1) UF pelo ViaCEP
      fetch('https://viacep.com.br/ws/' + zip + '/json/')
        .then(function (r) { return r.json(); })
        .then(function (cep) {
          if (!cep || cep.erro) throw new Error('CEP não encontrado.');
          var uf = cep.uf;

          // 2) Verifica carrinho atual — adiciona item fantasma se não tiver
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var has = (cart.items || []).some(function (i) { return String(i.id) === String(variantId); });
              if (has) return null;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1, properties: { _shipping_probe: '1' } })
              }).then(function (r) {
                if (!r.ok) throw new Error('Não foi possível consultar o frete para este produto.');
                ghostAdded = true;
                return null;
              });
            })
            .then(function () {
              // 3) Consulta shipping rates
              var params = new URLSearchParams({
                'shipping_address[zip]': zip,
                'shipping_address[country]': 'BR',
                'shipping_address[province]': uf
              });
              return fetch('/cart/shipping_rates.json?' + params.toString(), { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); });
            });
        })
        .then(function (data) {
          if (!data) return;
          var rates = (data.shipping_rates || []).filter(function (r) { return r && r.price != null; });
          if (rates.length === 0) {
            showMsg('Não há frete disponível para este CEP.', true);
            return;
          }
          var picked = pickThree(rates).sort(function (a, b) { return parseFloat(a.rate.price) - parseFloat(b.rate.price); });
          results.hidden = false;
          results.innerHTML = picked.map(renderRate).join('');
        })
        .catch(function (err) {
          showMsg(err && err.message ? err.message : 'Erro ao calcular frete. Tente novamente.', true);
        })
        .then(function () {
          // 4) Remove item fantasma, se adicionado
          if (ghostAdded) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 0 })
            }).then(function () {
              // sincroniza badge
              return fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) { updateCartBadge(cart.item_count); });
            });
          }
        })
        .catch(function () {})
        .then(cleanup);
    });
  }

  // ------------------------------------------------------------
  // PDP — Sticky CTA mobile (aparece quando botão principal sai da viewport,
  // some quando o footer entra — pra não tapar logo/info do rodapé)
  // ------------------------------------------------------------
  function initStickyMobileCta() {
    var sticky = document.querySelector('[data-sticky-cta]');
    if (!sticky) return;
    var stickyBtn = sticky.querySelector('[data-sticky-cta-btn]');
    var form = document.querySelector('form[action*="/cart/add"]');
    var mainCta = form && form.querySelector('button[type="submit"]');
    var footer = document.querySelector('[data-site-footer]');
    if (!mainCta || !('IntersectionObserver' in window)) return;

    var mainOut = false;
    var footerIn = false;
    function update() {
      var show = mainOut && !footerIn;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    new IntersectionObserver(function (entries) {
      mainOut = !entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(mainCta);

    if (footer) {
      new IntersectionObserver(function (entries) {
        footerIn = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(footer);
    }

    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  // ------------------------------------------------------------
  // Boot
  // ------------------------------------------------------------
  function boot() {
    // Garantia defensiva: drawers em estado fechado nunca bloqueiam cliques.
    var drawers = document.querySelectorAll('[data-cart-drawer], [data-search-drawer]');
    for (var i = 0; i < drawers.length; i++) {
      if (!drawers[i].classList.contains('is-open')) {
        drawers[i].style.pointerEvents = 'none';
      }
    }
    initMobileMenu();
    initSearchDrawer();
    initCartDrawer();
    initShippingCalculator();
    initStickyMobileCta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
